var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.482,
    height: 33.482,
    viewBox: "0 0 33.482 33.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tick",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 15.741,
    cy: 15.741,
    rx: 15.741,
    ry: 15.741,
    fill: "#003763",
    stroke: "",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M13.492,0,4.5,8.995,0,4.5",
    transform: "translate(8.995 11.244)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedRadio);
export default __webpack_public_path__ + "static/media/CheckedRadio.906b1b40e0db81638a22502014e5f876.svg";
export { ForwardRef as ReactComponent };